const NotificationNewRequest = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="48" height="48" rx="16" fill="#F9F6FC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17V30.5858L18.2929 28.2929C18.4804 28.1054 18.7348 28 19 28H31C31.2652 28 31.5196 27.8946 31.7071 27.7071C31.8946 27.5196 32 27.2652 32 27V17C32 16.7348 31.8946 16.4804 31.7071 16.2929C31.5196 16.1054 31.2652 16 31 16H17ZM14.8787 14.8787C15.4413 14.3161 16.2044 14 17 14H31C31.7957 14 32.5587 14.3161 33.1213 14.8787C33.6839 15.4413 34 16.2043 34 17V27C34 27.7957 33.6839 28.5587 33.1213 29.1213C32.5587 29.6839 31.7957 30 31 30H19.4142L15.7071 33.7071C15.4211 33.9931 14.991 34.0787 14.6173 33.9239C14.2436 33.7691 14 33.4045 14 33V17C14 16.2044 14.3161 15.4413 14.8787 14.8787Z"
        fill="#663497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 18C24.5523 18 25 18.4477 25 19V25C25 25.5523 24.5523 26 24 26C23.4477 26 23 25.5523 23 25V19C23 18.4477 23.4477 18 24 18Z"
        fill="#663497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 22C20 21.4477 20.4477 21 21 21H27C27.5523 21 28 21.4477 28 22C28 22.5523 27.5523 23 27 23H21C20.4477 23 20 22.5523 20 22Z"
        fill="#663497"
      />
    </svg>
  );
};

export default NotificationNewRequest;
